export enum ConfirmCodeType {
	REQUEST_SECURITY_CHANGE,
	DEPOSIT_REQUEST,
	WITHDRAWAL_REQUEST,
	BETWEEN_MY_WALLETS,
	INTERNAL_TRANSFER_REQUEST,
	BUY_AND_SELL_REQUEST,
	EXCHANGE_SERVICE_REQUEST,
	VOUCHER,
	POINT_WITHDRAWAL_REQUEST,
	SMS_PANEL_CHARGE_REQUEST,
	PEER_TO_PEER
}
